import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import DocumentHead from 'legacyComponents/documentHead';
import { SectionBanner, Paragraph, Box } from 'components';
import { MainWrapper } from 'legacyComponents/styled/lib';

import OrderList from 'apps/order/orderList';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';

import { useNoAuthRedirect, useClientStore } from '../../hooks';

const OrdersPage = observer(() => {
  const clientStore = useClientStore();
  const { isMobile } = clientStore;
  useNoAuthRedirect();

  const { activeSpace } = clientStore;
  const title =
    activeSpace?.spaceType === 'INITIATIVE'
      ? `${activeSpace?.content?.title}'s Orders`
      : 'My Orders';

  return (
    <>
      <DocumentHead title={title} />
      <MainWrapper>
        {!isMobile && (
          <SectionBanner
            bannerId='order-card'
            imageSrc='/assets/banners/005.svg'
            title='Build a supply chain and get your product to market.'
            buttonText='Start your Journey'
            linkName='https://wikifactory-manu.typeform.com/to/d86Nu6Nm'
            paddingTop='large'
            paddingBottom='xlarge'
            eventCallback={() => analytics.sendEvent(BANNER_ACTIONS.ORDERS)}
          >
            <Box>
              <Paragraph>
                From initial kickstarter batches to serial production, we can
                <strong>
                  {' '}
                  support you on your manufacturing journey
                </strong>.{' '}
              </Paragraph>
              <Paragraph>
                <strong>Organize your product data</strong> in our cloud-based
                PDM and we’ll help you get your product to market,{' '}
                <strong>faster and smarter</strong>.
              </Paragraph>
            </Box>
          </SectionBanner>
        )}
        <OrderList />
      </MainWrapper>
    </>
  );
});
OrdersPage.propTypes = {
  routerStore: PropTypes.object,
};

export default OrdersPage;
